import React from 'react';
import FormGroupSelectMultiple from "../../formGroupSelectMultiple";

const Step1 = (props) => {
    if (props.currentStep !== 1)
        return null;

    let caseStageOptions = props.caseStages.map(stage => {
        return {id: stage.id, name: stage.name}
    });
    return (
        <div >
            <p className="premiumSettingsWizard-step-message">{props.stepMessage}</p>
            <div className="form-group">
                <div className='col-sm-3'>
                    <label className="control-label.text-left formGroupSelectInput-label">
                        {'Case stages'}
                        <span>{' '}*</span>
                    </label>
                </div>
                <div className={'col-sm-6'}>
                    {caseStageOptions.map((item, index) => {
                        return <div key={index} className="">
                            <input
                                name='appFormRefSettings-check_box' checked={ props.handleCaseStagesCheckedState(item.id, 'selectedCaseStages')}
                                id={index + 'selectedCaseStages'}
                                type="checkbox" className="appFormRefSettings-check_box"
                                onChange={(evt) => props.handleCaseStagesSelectMultipleChange(evt.target.checked, item)}
                            />
                            <label className=""  htmlFor={index + 'selectedCaseStages'}></label>
                            <span className="applicationsAndPolicies-checkbox-label applicationsAndPolicies-font">{item.name}</span>
                        </div>;
                    })}
                </div>
            </div>
        </div>
    )
};

export default Step1;